import React, { FormEvent, useState } from 'react'
import { Form } from 'react-router-dom';
import { Alert, Button, Checkbox, FormControlLabel, IconButton } from '@mui/material';

import { useUserContext } from '../../contexts/userContext';

import { IEmployeePermissions } from '../../types/employee';

import { EmployeeService } from '../../services/employeeService';

import { AppConfig } from '../../config/appConfig';

import '../../styles/employeePermissionsForm.scss';

export interface IEmployeePermissionsForm {
	id: string;
	permissions: IEmployeePermissions;
}

const EmployeePermissionsForm: React.FunctionComponent<IEmployeePermissionsForm> = ({ id, permissions }) => {
	const [formFields, setFormFields] = useState<IEmployeePermissions>({
		canAccessHwiOnline: permissions.canAccessHwiOnline ? permissions.canAccessHwiOnline : false,
		canChangeClosedThroughDate: permissions.canChangeClosedThroughDate ? permissions.canChangeClosedThroughDate : false,
		canDeleteShipments: permissions.canDeleteShipments ? permissions.canDeleteShipments : false,
		canManageCustomerDocuments: permissions.canManageCustomerDocuments ? permissions.canManageCustomerDocuments : false,
		canManageCustomers: permissions.canManageCustomers ? permissions.canManageCustomers : false,
		canManageDocuments: permissions.canManageDocuments ? permissions.canManageDocuments : false,
		canManageEmployees: permissions.canManageEmployees ? permissions.canManageEmployees : false,
		canManageExpenses: permissions.canManageExpenses ? permissions.canManageExpenses : false,
		canManageFacilities: permissions.canManageFacilities ? permissions.canManageFacilities : false,
		canManageMaterialInventory: permissions.canManageMaterialInventory ? permissions.canManageMaterialInventory : false,
		canManageMaterialPrices: permissions.canManageMaterialPrices ? permissions.canManageMaterialPrices : false,
		canManageMaterials: permissions.canManageMaterials ? permissions.canManageMaterials : false,
		canManageShipments: permissions.canManageShipments ? permissions.canManageShipments : false,
		canReadBatches: permissions.canReadBatches ? permissions.canReadBatches : false,
		canManageBatches: permissions.canManageBatches ? permissions.canManageBatches : false,
		canManageTransporters: permissions.canManageTransporters ? permissions.canManageTransporters : false,
		canManageVendors: permissions.canManageVendors ? permissions.canManageVendors : false,
		canManageWasteCharacterization: permissions.canManageWasteCharacterization ? permissions.canManageWasteCharacterization : false,
		canUnlockFinalizedShipments: permissions.canUnlockFinalizedShipments ? permissions.canUnlockFinalizedShipments : false,
		canChangeShipmentVendor: permissions.canChangeShipmentVendor ? permissions.canChangeShipmentVendor : false,
		canManageTrailers: permissions.canManageTrailers ? permissions.canManageTrailers : false,
		canAccessTils: permissions.canAccessTils ? permissions.canAccessTils : false,
		canManageLoads: permissions.canManageLoads ? permissions.canManageLoads : false,
		canApproveEscalatedShipments: permissions.canApproveEscalatedShipments ? permissions.canApproveEscalatedShipments : false,
		canCompleteShipments: permissions.canCompleteShipments ? permissions.canCompleteShipments : false,
		canReviewShipments: permissions.canReviewShipments ? permissions.canReviewShipments : false,
		canQBEnter: permissions.canQBEnter ? permissions.canQBEnter : false,
		canQBAudit: permissions.canQBAudit ? permissions.canQBAudit : false,
		canViewReportCostCredit: permissions.canViewReportCostCredit ? permissions.canViewReportCostCredit : false,
		canViewReportExpense: permissions.canViewReportExpense ? permissions.canViewReportExpense : false,
		canViewReportMaterialPricing: permissions.canViewReportMaterialPricing ? permissions.canViewReportMaterialPricing : false,
		canViewReportMaterial: permissions.canViewReportMaterial ? permissions.canViewReportMaterial : false,
		canViewReportMonthlySummary: permissions.canViewReportMonthlySummary ? permissions.canViewReportMonthlySummary : false,
		canViewReportMonthlySummaryByVendor: permissions.canViewReportMonthlySummaryByVendor ? permissions.canViewReportMonthlySummaryByVendor : false,
		canViewReportShipmentHistory: permissions.canViewReportShipmentHistory ? permissions.canViewReportShipmentHistory : false,
		canViewReportShipmentByVendor: permissions.canViewReportShipmentByVendor ? permissions.canViewReportShipmentByVendor : false,
		canViewReportCustomerVendorDelta: permissions.canViewReportCustomerVendorDelta ? permissions.canViewReportCustomerVendorDelta : false,
		canViewReportShipmentStatus: permissions.canViewReportShipmentStatus ? permissions.canViewReportShipmentStatus : false,
		canViewReportSummary: permissions.canViewReportSummary ? permissions.canViewReportSummary : false,
		canViewSensitiveDocuments: permissions.canViewSensitiveDocuments ? permissions.canViewSensitiveDocuments : false,
		canViewReportMaterialInventory: permissions.canViewReportMaterialInventory ? permissions.canViewReportMaterialInventory : false,
		canViewReportShipmentManifestByVendor: permissions.canViewReportShipmentManifestByVendor ? permissions.canViewReportShipmentManifestByVendor : false,
		canBypassVendorWorkflow: permissions.canBypassVendorWorkflow ? permissions.canBypassVendorWorkflow : false,
		canUseShipmentPacketAudit: permissions.canUseShipmentPacketAudit ? permissions.canUseShipmentPacketAudit : false,
		canDeleteDocuments: permissions.canDeleteDocuments ? permissions.canDeleteDocuments : false,
		canManageReportRegistrations: permissions.canManageReportRegistrations ? permissions.canManageReportRegistrations : false,
		canManageApplicationSettings: permissions.canManageApplicationSettings ? permissions.canManageApplicationSettings : false,
		canViewReportClosing: permissions.canViewReportClosing ? permissions.canViewReportClosing : false,
		canViewReportVendorsAcrossCustomers: permissions.canViewReportVendorsAcrossCustomers ? permissions.canViewReportVendorsAcrossCustomers : false,
		canEditMaterialInventory: permissions.canEditMaterialInventory ? permissions.canEditMaterialInventory : false,
		canManageLoadWorkflow: permissions.canManageLoadWorkflow ? permissions.canManageLoadWorkflow : false,
		canManageDeletedLoads: permissions.canManageDeletedLoads ? permissions.canManageDeletedLoads : false,
		canManageDeletedShipments: permissions.canManageDeletedShipments ? permissions.canManageDeletedShipments : false,
		canViewExpensesOnly: permissions.canViewExpensesOnly ? permissions.canViewExpensesOnly : false,
		canManageContainers: permissions.canManageContainers ? permissions.canManageContainers : false,
		canExportCustomers: permissions.canExportCustomers ? permissions.canExportCustomers : false,
		canExportVendors: permissions.canExportVendors ? permissions.canExportVendors : false,
		canExportTransporters: permissions.canExportTransporters ? permissions.canExportTransporters : false,
		canChangeShipmentDatesForVendorsRequiringEscalatedPermission: permissions.canChangeShipmentDatesForVendorsRequiringEscalatedPermission ? permissions.canChangeShipmentDatesForVendorsRequiringEscalatedPermission : false,
	});
	const [isSaving, setIsSaving] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string | undefined>();
	const [successMessage, setSuccessMessage] = useState<string | undefined>();
	const userContext = useUserContext();

	const handleChangeCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
		const name = event.target.name;
		const value = event.target.checked;
		setFormFields({ ...formFields, [name]: value });
	};

	const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		clearSaveResult();
		setIsSaving(true);

		EmployeeService.setPermissions(parseInt(id), formFields)
			.then((response) => {
				console.log('EmployeeService.setPermissions: SUCCESS', response);
				syncPermissions(permissions);
				if (id == userContext.id) {
					syncPermissions(userContext.permissions);
				}
				setSuccessMessage("Employee permissions have been saved.");
				setTimeout(() => {
					setSuccessMessage(undefined);
				}, AppConfig.editSuccessToastMs);
			})
			.catch((error) => {
				console.log('EmployeeService.setPermissions: ERROR', error);
				setErrorMessage("We encountered an error while processing your request. Please try again.");
			}).finally(() => {
				setIsSaving(false);
				window.scrollTo(0, 0);
			});
	}

	const syncPermissions = (target: IEmployeePermissions) => {
		target.canAccessHwiOnline = formFields.canAccessHwiOnline;
		target.canChangeClosedThroughDate = formFields.canChangeClosedThroughDate;
		target.canDeleteShipments = formFields.canDeleteShipments;
		target.canManageCustomerDocuments = formFields.canManageCustomerDocuments;
		target.canManageCustomers = formFields.canManageCustomers;
		target.canManageDocuments = formFields.canManageDocuments;
		target.canManageEmployees = formFields.canManageEmployees;
		target.canManageExpenses = formFields.canManageExpenses;
		target.canManageFacilities = formFields.canManageFacilities;
		target.canManageMaterialInventory = formFields.canManageMaterialInventory;
		target.canManageMaterialPrices = formFields.canManageMaterialPrices;
		target.canManageMaterials = formFields.canManageMaterials;
		target.canManageShipments = formFields.canManageShipments;
		target.canReadBatches = formFields.canReadBatches;
		target.canManageBatches = formFields.canManageBatches;
		target.canManageTransporters = formFields.canManageTransporters;
		target.canManageVendors = formFields.canManageVendors;
		target.canManageWasteCharacterization = formFields.canManageWasteCharacterization;
		target.canUnlockFinalizedShipments = formFields.canUnlockFinalizedShipments;
		target.canChangeShipmentVendor = formFields.canChangeShipmentVendor;
		target.canManageTrailers = formFields.canManageTrailers;
		target.canAccessTils = formFields.canAccessTils;
		target.canManageLoads = formFields.canManageLoads;
		target.canApproveEscalatedShipments = formFields.canApproveEscalatedShipments;
		target.canCompleteShipments = formFields.canCompleteShipments;
		target.canReviewShipments = formFields.canReviewShipments;
		target.canQBEnter = formFields.canQBEnter;
		target.canQBAudit = formFields.canQBAudit;
		target.canViewReportCostCredit = formFields.canViewReportCostCredit;
		target.canViewReportExpense = formFields.canViewReportExpense;
		target.canViewReportMaterialPricing = formFields.canViewReportMaterialPricing;
		target.canViewReportMaterial = formFields.canViewReportMaterial;
		target.canViewReportMonthlySummary = formFields.canViewReportMonthlySummary;
		target.canViewReportMonthlySummaryByVendor = formFields.canViewReportMonthlySummaryByVendor
		target.canViewReportShipmentHistory = formFields.canViewReportShipmentHistory;
		target.canViewReportShipmentByVendor = formFields.canViewReportShipmentByVendor;
		target.canViewReportCustomerVendorDelta = formFields.canViewReportCustomerVendorDelta;
		target.canViewReportShipmentStatus = formFields.canViewReportShipmentStatus;
		target.canViewReportSummary = formFields.canViewReportSummary;
		target.canViewSensitiveDocuments = formFields.canViewSensitiveDocuments;
		target.canViewReportMaterialInventory = formFields.canViewReportMaterialInventory;
		target.canViewReportShipmentManifestByVendor = formFields.canViewReportShipmentManifestByVendor;
		target.canBypassVendorWorkflow = formFields.canBypassVendorWorkflow;
		target.canUseShipmentPacketAudit = formFields.canUseShipmentPacketAudit;
		target.canDeleteDocuments = formFields.canDeleteDocuments;
		target.canManageReportRegistrations = formFields.canManageReportRegistrations;
		target.canManageApplicationSettings = formFields.canManageApplicationSettings;
		target.canViewReportClosing = formFields.canViewReportClosing;
		target.canViewReportVendorsAcrossCustomers = formFields.canViewReportVendorsAcrossCustomers;
		target.canEditMaterialInventory = formFields.canEditMaterialInventory;
		target.canManageLoadWorkflow = formFields.canManageLoadWorkflow;
		target.canManageDeletedLoads = formFields.canManageDeletedLoads;
		target.canManageDeletedShipments = formFields.canManageDeletedShipments;
		target.canViewExpensesOnly = formFields.canViewExpensesOnly;
		target.canManageContainers = formFields.canManageContainers;
		target.canExportCustomers = formFields.canExportCustomers;
		target.canExportVendors = formFields.canExportVendors;
		target.canExportTransporters = formFields.canExportTransporters;
		target.canChangeShipmentDatesForVendorsRequiringEscalatedPermission = formFields.canChangeShipmentDatesForVendorsRequiringEscalatedPermission;
	};

	const clearSaveResult = () => {
		setErrorMessage(undefined);
		setSuccessMessage(undefined);
	};

	//#region Make canManageExpenses and canViewExpensesOnly mutually exclusive
	const handleOnCanViewExpensesOnlyChange = (event: React.MouseEvent<HTMLButtonElement>) => {
		const newValue = !formFields.canViewExpensesOnly;
		setFormFields(prev => ({ ...prev, canViewExpensesOnly: newValue, canManageExpenses: (newValue && formFields.canManageExpenses) ? false : prev.canManageExpenses }));
	};

	const handleOnCanManageExpensesChange = (event: React.MouseEvent<HTMLButtonElement>) => {
		const newValue = !formFields.canManageExpenses;
		setFormFields(prev => ({ ...prev, canManageExpenses: newValue, canViewExpensesOnly: (newValue && formFields.canViewExpensesOnly) ? false : prev.canViewExpensesOnly }));
	};
	//#endregion

	return (
		<section className="hwi-employee-permissions-form">
			{successMessage &&
				<Alert className="alert-success"
					severity="success"
					action={<IconButton onClick={() => { setSuccessMessage(undefined); }} size='small'>X</IconButton>}>
					{successMessage}
				</Alert>
			}
			{errorMessage &&
				<Alert className="alert-error"
					severity="error"
					action={<IconButton onClick={() => { setErrorMessage(undefined); }} size='small'>X</IconButton>}>
					{errorMessage}
				</Alert>
			}
			<Form onSubmit={(event) => handleSubmit(event)}>
				<h3>HWI Online</h3>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canAccessHwiOnline" checked={formFields.canAccessHwiOnline} onChange={handleChangeCheck}></Checkbox>} label="Can Access HWI Online" />
				</div>
				<br></br>

				<h3>Entity Management</h3>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageApplicationSettings" checked={formFields.canManageApplicationSettings} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Application Settings" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageCustomers" checked={formFields.canManageCustomers} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Customers" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canExportCustomers" checked={formFields.canExportCustomers} onChange={handleChangeCheck}></Checkbox>} label="Can Export Customers" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageCustomerDocuments" checked={formFields.canManageCustomerDocuments} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Customer Documents" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageEmployees" checked={formFields.canManageEmployees} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Employees" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageVendors" checked={formFields.canManageVendors} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Vendors" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageFacilities" checked={formFields.canManageFacilities} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Vendors (Facilities)" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canExportVendors" checked={formFields.canExportVendors} onChange={handleChangeCheck}></Checkbox>} label="Can Export Vendors" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageTransporters" checked={formFields.canManageTransporters} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Transporters" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canExportTransporters" checked={formFields.canExportTransporters} onChange={handleChangeCheck}></Checkbox>} label="Can Export Transporters" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageMaterials" checked={formFields.canManageMaterials} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Materials" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageMaterialPrices" checked={formFields.canManageMaterialPrices} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Material Prices" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageContainers" checked={formFields.canManageContainers} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Containers" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageDocuments" checked={formFields.canManageDocuments} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Documents" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canDeleteDocuments" checked={formFields.canDeleteDocuments} onChange={handleChangeCheck}></Checkbox>} label="Can Delete Documents" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewSensitiveDocuments" checked={formFields.canViewSensitiveDocuments} onChange={handleChangeCheck}></Checkbox>} label="Can View Sensitive Documents" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageExpenses" checked={formFields.canManageExpenses} onClick={(e) => { handleOnCanManageExpensesChange(e); }}></Checkbox>} label="Can Manage Expenses" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewExpensesOnly" checked={formFields.canViewExpensesOnly} onClick={(e) => { handleOnCanViewExpensesOnlyChange(e); }}></Checkbox>} label="Can View Expenses Only" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageReportRegistrations" checked={formFields.canManageReportRegistrations} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Report Registrations" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageWasteCharacterization" checked={formFields.canManageWasteCharacterization} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Waste Characterization" />
				</div>
				<br></br>

				<h3>Reports</h3>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportCustomerVendorDelta" checked={formFields.canViewReportCustomerVendorDelta} onChange={handleChangeCheck}></Checkbox>} label="Can View Customer Vendor Delta Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportShipmentByVendor" checked={formFields.canViewReportShipmentByVendor} onChange={handleChangeCheck}></Checkbox>} label="Can View Shipment Report by Vendor" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportShipmentStatus" checked={formFields.canViewReportShipmentStatus} onChange={handleChangeCheck}></Checkbox>} label="Can View Shipment Status Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportShipmentHistory" checked={formFields.canViewReportShipmentHistory} onChange={handleChangeCheck}></Checkbox>} label="Can View Shipment History Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportMaterial" checked={formFields.canViewReportMaterial} onChange={handleChangeCheck}></Checkbox>} label="Can View Customer Material Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportExpense" checked={formFields.canViewReportExpense} onChange={handleChangeCheck}></Checkbox>} label="Can View Customer Expense Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportSummary" checked={formFields.canViewReportSummary} onChange={handleChangeCheck}></Checkbox>} label="Can View Customer Summary Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportMaterialPricing" checked={formFields.canViewReportMaterialPricing} onChange={handleChangeCheck}></Checkbox>} label="Can View Material Pricing Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportMonthlySummary" checked={formFields.canViewReportMonthlySummary} onChange={handleChangeCheck}></Checkbox>} label="Can View Monthly Summary Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportMonthlySummaryByVendor" checked={formFields.canViewReportMonthlySummaryByVendor} onChange={handleChangeCheck}></Checkbox>} label="Can View Monthly Summary Report by Vendor" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportVendorsAcrossCustomers" checked={formFields.canViewReportVendorsAcrossCustomers} onChange={handleChangeCheck}></Checkbox>} label="Can View Vendors Across Customers Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportCostCredit" checked={formFields.canViewReportCostCredit} onChange={handleChangeCheck}></Checkbox>} label="Can View Cost Credit Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportMaterialInventory" checked={formFields.canViewReportMaterialInventory} onChange={handleChangeCheck}></Checkbox>} label="Can View Material Inventory Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportShipmentManifestByVendor" checked={formFields.canViewReportShipmentManifestByVendor} onChange={handleChangeCheck}></Checkbox>} label="Can View Shipment Manifest by Vendor Report" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canViewReportClosing" checked={formFields.canViewReportClosing} onChange={handleChangeCheck}></Checkbox>} label="Can View Closing Report" />
				</div>
				<br></br>

				<h3>Shipments</h3>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageShipments" checked={formFields.canManageShipments} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Shipments" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageDeletedShipments" checked={formFields.canManageDeletedShipments} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Deleted Shipments" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canReadBatches" checked={formFields.canReadBatches} onChange={handleChangeCheck}></Checkbox>} label="Can Read Batches" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageBatches" checked={formFields.canManageBatches} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Batches" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canApproveEscalatedShipments" checked={formFields.canApproveEscalatedShipments} onChange={handleChangeCheck}></Checkbox>} label="Can De-escalate Shipments" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canReviewShipments" checked={formFields.canReviewShipments} onChange={handleChangeCheck}></Checkbox>} label="Can Review Shipments" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canQBEnter" checked={formFields.canQBEnter} onChange={handleChangeCheck}></Checkbox>} label="Can Enter QB" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canQBAudit" checked={formFields.canQBAudit} onChange={handleChangeCheck}></Checkbox>} label="Can Audit QB" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canCompleteShipments" checked={formFields.canCompleteShipments} onChange={handleChangeCheck}></Checkbox>} label="Can Complete Shipments" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canUnlockFinalizedShipments" checked={formFields.canUnlockFinalizedShipments} onChange={handleChangeCheck}></Checkbox>} label="Can Unlock Finalized Shipments" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canChangeShipmentVendor" checked={formFields.canChangeShipmentVendor} onChange={handleChangeCheck}></Checkbox>} label="Can Change Shipment Vendor" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canChangeClosedThroughDate" checked={formFields.canChangeClosedThroughDate} onChange={handleChangeCheck}></Checkbox>} label="Can Change Closed-Through Date" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canChangeShipmentDatesForVendorsRequiringEscalatedPermission" checked={formFields.canChangeShipmentDatesForVendorsRequiringEscalatedPermission} onChange={handleChangeCheck}></Checkbox>} label="Can Change Shipment Dates For Vendors Requiring Escalated Permission" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canDeleteShipments" checked={formFields.canDeleteShipments} onChange={handleChangeCheck}></Checkbox>} label="Can Delete Shipments" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canUseShipmentPacketAudit" checked={formFields.canUseShipmentPacketAudit} onChange={handleChangeCheck}></Checkbox>} label="Can Use Shipment Packet Audit" />
				</div>
				<br></br>

				<h3>TILS</h3>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageTrailers" checked={formFields.canManageTrailers} onChange={handleChangeCheck}></Checkbox>} label="Can Edit Trailer Inventory" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageMaterialInventory" checked={formFields.canManageMaterialInventory} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Material Inventory" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canEditMaterialInventory" checked={formFields.canEditMaterialInventory} onChange={handleChangeCheck}></Checkbox>} label="Can Edit Material Inventory Records" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageLoads" checked={formFields.canManageLoads} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Loads" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageDeletedLoads" checked={formFields.canManageDeletedLoads} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Deleted Loads" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canManageLoadWorkflow" checked={formFields.canManageLoadWorkflow} onChange={handleChangeCheck}></Checkbox>} label="Can Manage Load Workflow" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canBypassVendorWorkflow" checked={formFields.canBypassVendorWorkflow} onChange={handleChangeCheck}></Checkbox>} label="Can Bypass Vendor Workflow" />
				</div>
				<div className="row">
					<FormControlLabel control={<Checkbox name="canAccessTils" checked={formFields.canAccessTils} onChange={handleChangeCheck}></Checkbox>} label="Can Access TILS" />
				</div>
				<br></br>
				<br></br>
				<div className="row controls">
					<Button type="submit" className="save-button" variant="contained">{isSaving ? "Saving..." : "Save Permissions"}</Button>
				</div>
			</Form>
		</section>
	)
}

export default EmployeePermissionsForm;